<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="backToContractServices()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <form [formGroup]="contractsForm">
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group">
                            <label for="empid">Contract Type*</label>
                            <ng-select id="contractType"  formControlName="contractType" [(ngModel)]="selectedContractType" [ngClass]="{'is-invalid': submitted && f.contractType.errors}" placeholder="Select contract type">
                                <ng-option *ngFor="let contractType of contractTypes" [value]="contractType.ContractID">{{contractType.ContractID}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages?.contractType">
                                <div class="error-message" *ngIf="f.contractType.hasError(validation.type) && ((f.contractType.dirty  || f.contractType.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label for="empid">Contract ID*</label>
                                <input id="empid" class="form-control" 
                                formControlName="contractID" placeholder="Contract ID" type="text" 
                                [ngClass]="{'is-invalid': submitted && f.contractID.errors}">
                                <div *ngFor="let validation of validation_messages.contractID">
                                    <div class="error-message" *ngIf="f.contractID.hasError(validation.type) && ((f.contractID.dirty  || f.contractID.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label for="empid">Discount(%)*</label>
                                <input id="amount" class="form-control" formControlName="discount_percent" placeholder="Discount(%) " type="number" [ngClass]="{'is-invalid': submitted && f.discount_percent.errors}">
                                <div *ngFor="let validation of validation_messages.discount_percent">
                                    <div class="error-message" *ngIf="f.discount_percent.hasError(validation.type) && ((f.discount_percent.dirty  || f.discount_percent.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group col-md-3">
                            <label for="inputEmail4">Effective Start Date</label>
    
                            <input id="effectsDate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true}" 
                            bsDatepicker  formControlName="effectsDate" class="form-control"
                            placeholder="Select start date">
                           
                            <div *ngFor="let validation of validation_messages.effectsDate">
                                <div class="error-message"
                                    *ngIf="f.effectsDate.hasError(validation.type) && 
                                                                       ((f.effectsDate.dirty ||  f.effectsDate.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form-group col-md-3" >
                            <label for="inputEmail4">Description</label>
                            <textarea class="form-control" formControlName="description" placeholder="Description" type="number" [ngClass]="{'is-invalid': submitted && f.description.errors}">
                        </textarea>
                           
                            
                        </div> -->
                   </div>
            <div>
                <b>Note : We are taking the service amounts from RETAIL-BASE and applying discounts according to the provided discount rates.</b>
            </div>
                    <div class="row">
                        <div class="col-md-12 py-3">
                          
                            <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddContracts(contractsForm.value)" >Add Contracts</button>
                            </div>
                    </div>
    
           
            </form>
           
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>